<script>
/**
 * Type         : Page component
 * Title        : 화물조회 페이지
 * Description  : 고객 화물조회 페이지
 * 
 */

import ParcelList from "@/components/customer/ParcelList.vue"

export default {
  name: "PageCustomerParcelInquiry",
  meta: {
    title: "고객-배송상품조회"
  },
  components: {
    ParcelList,
  },
  /*
  setup(){
  },
  */
  data() {
    return {
      navCurrent      : 'parcel-info',
      hblNo           : '',
      receiverMobileLast4: '',
    }
  },
  methods: {
    /**
     * Title        : 화물조회
     * Status       : Actived
     * Description  : 화물조회
     */
    async loadParcelList() {
      const hblNo = this.hblNo.trim()
      const receiverMobileLast4 = this.receiverMobileLast4.trim()

      if (!hblNo) {
        this.$q.notify({
          type: 'warning',
          message: 'H/BL 번호를 입력해 주세요.',
          position: 'top',
          timeout: 3000,
        })
        return
      }

      if (!/^\d{4}$/.test(receiverMobileLast4)) {
        this.$q.notify({
          type: 'warning',
          message: '수취인 전화번호 뒷자리 4자리를 입력해 주세요.',
          position: 'top',
          timeout: 3000,
        })
        return
      }

      this.$log.debug("[ Axios / 고객 배송상품조회 ] hblNo = ", hblNo)

      let payload = {
        hblNo,
        receiverMobileLast4,
      }
      this.$log.debug("[ Axios / 고객 배송상품조회 ] payload = ", payload)

      let config = {
        method  : "POST",
        url     : "/api/parcel/byHblNo",
        data    : payload,
        name    : "[ Axios / 고객 배송상품조회 ]"
      }

      await this.$http(config)
        .then(res => {
          const parcelList = res.data
          // Response data 를 data 에 넣는다.
          this.$store.dispatch('loadParcel', res.data)

          if(parcelList?.length === 0)
            {
              this.$q.notify({
                type: 'positive',
                message: '조회된 배송상품이 없습니다.',
                position: 'top',
                timeout: 3000,
              })
            }
        })
        .catch((err) => {
          this.$log.debug("[ Axios / 고객 배송상품조회 / 실패 ]", err)
          this.$q.notify({
            type: 'negative',
            message: err.response?.data?.message || '배송 상품 조회에 실패 했습니다.',
            position: 'top',
            timeout: 3000,
          })
      })
    },
    normalizeMobileLast4(value) {
      this.receiverMobileLast4 = String(value || '').replace(/\D/g, '').slice(0, 4)
    },

    /**
     * Title        : 화물조회
     * Status       : Actived
     * Description  : 화물조회
     */
    async loginedLoadParcelList(cid) {
      // 조회 조건 검토
      let payload = {
        "id": cid,
      }

      let config = {
        method  : "POST",
        url     : "/api/parcel/byCustomer",
        data    : payload,
        name    : "[ Axios / 로그인된 고객 배송조회 ]"
      }

      await this.$http(config)
        .then(res => {
          const parcelList = res.data

          // Response data 를 data 에 넣는다.          
          this.$store.dispatch('loadParcel', res.data)

          if(this.$store.getters.getSessionStatus && parcelList.length === 0)
            // alert('고객님은 아직 등록하신 배송상품이 없습니다.')
            this.$q.notify({
              type: 'positive',
              message: '배송상품 조회를 완료했습니다.',
              position: 'top',
              timeout: 3000,
            })

        })
        .catch((err) => {
          this.$log.debug("/api/parcel/byCustomer", err)
          alert('배송 상품 조회에 실패 했습니다.')
        })
    },

    /**
     * Title        : 검증
     * Status       : Actived
     * Description  : 
     */
    validator(data) {
      let templength = data.mobile + data.email + data.courierCode.value + data.courierNum
      this.$log.debug("Validator executed templength = ", templength)

      return (templength === "")? false:true;
    },
  },
  mounted() {
    this.$log.debug("[ ParcelInfo.vue / Mounted ]")

    // vuex store 에서 로그인상태 조회 후 배송상품 조회
    const sess = JSON.parse(sessionStorage.getItem('vuexStore'))
      
    this.$log.debug("checkSession sess = ", sess)

    let customerId
    if(sess !== undefined && sess !== null){
      customerId = sess.user.localSession.id
      this.$log.debug("checkSession sessData = ", customerId)
      this.$log.debug("로그인 상태임")
      // this.loginedLoadParcelList(customerId)

    }
    
  },
}
</script>

<template>

  <main id="site-container">
    <div class="container doc-page q-py-xl">
      <div class="row justify-center q-mt-xl">
        <div class="col-12 col-md-8">
          <div class="lookup-guide-card">
            <div class="text-h5 text-weight-bold q-mb-sm">배송 진행상태 조회</div>
            <div class="text-body2 text-grey-7">
              안내받은 H/BL 번호와 수취인 전화번호 뒷자리 4자리를 입력하면 현재 배송 진행상태를 확인할 수 있습니다.
              H/BL 번호를 모르는 경우 배송을 접수한 파트너사 또는 AONE 담당자에게 문의해 주세요.
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-center q-mt-xl">
        <div class="col-12 col-md-9">
          <div class="lookup-form">
          <q-input
            class="search-bar"
            v-model="hblNo"
            outlined
            rounded
            label="H/BL No."
            @keyup.enter="loadParcelList" />

          <q-input
            class="mobile-last4-input"
            v-model="receiverMobileLast4"
            outlined
            rounded
            maxlength="4"
            inputmode="numeric"
            label="전화번호 뒷자리 4자리"
            @update:model-value="normalizeMobileLast4"
            @keyup.enter="loadParcelList">

            <template v-slot:append>
              <q-btn
                round
                color="primary"
                icon="search"
                @click="loadParcelList" />
            </template>

          </q-input>
          </div>
        </div>
      </div>

      <div class="row" v-if="this.$store.getters.getParcelList.length === 0">
        <div class="col text-center">
          <h4>고객님의 배송상품을 검색해보세요.</h4>
          <p class="text-grey-7">
            아직 조회 결과가 없습니다. H/BL 번호와 전화번호 뒷자리 4자리를 입력한 뒤 검색 버튼을 눌러주세요.
          </p>
        </div>
      </div>

    </div>
    <div class="container doc-page q-pb-xl"
      v-if="this.$store.getters.getParcelList.length > 0" >
      <div class="row q-pb-xl">
        <div class="col">
          <div class="comp-box">
            <ParcelList />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-bar {
  max-width: 420px;
  width: 100%;
  min-width: 260px;
}

.mobile-last4-input {
  max-width: 240px;
  width: 100%;
  min-width: 180px;
}

.lookup-form {
  display: flex;
  justify-content: center;
  gap: 12px;
  width: 100%;
}

@media (max-width: 599px) {
  .lookup-form {
    flex-direction: column;
    align-items: stretch;
  }

  .search-bar,
  .mobile-last4-input {
    max-width: none;
  }
}

.lookup-guide-card {
  padding: 28px;
  border: 1px solid #e0e6ef;
  border-radius: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #f5f9ff 100%);
  text-align: center;
}
</style>
